<template>
	<div class="page pagehiden">
	    <div class="blurImage" :style="{backgroundImage: 'url('+currentImage['im']+')'}">
	    </div>
	    <div class="page scaleRound">
	        <div class="dong4-im div41" :style="imageStyle" @click="wxPreview">
	        </div>
	        <div class="dong4-im div42" :style="imageStyle" @click="wxPreview">
	        </div>
	        <div class="dong4-im div43" :style="imageStyle" @click="wxPreview">
	        </div>
	        <div class="dong4-im div44" :style="imageStyle" @click="wxPreview">
	        </div>
	        <div class="dong4-im div45" :style="imageStyle" @click="wxPreview">
	        </div>
	    </div>
	</div>
</template>

<script>
	export default {
		name: 'dong4',
		props: ['mode', 'currentImage'],
		data () {
			return {
				imageStyle: {
					width: '0px',
					height: '0px',
					top: '50%',
					marginTop: '0px',
					left: '0px',
					backgroundImage: 'url()'
				}
			}
		},
		watch: {
			currentImage () {
				this.analyseImage();
			}
		},
		mounted () {
			this.analyseImage();
		},
		methods: {
			wxPreview () {
				this.$emit('wxPreview', this.currentImage);
			},
			analyseImage () {
				let twidth = this.$env.bw,
					theight = this.$env.bw * 1.25;
				this.imageStyle['width'] = twidth + 'px';
				this.imageStyle['height'] = theight.toString() + 'px';
				this.imageStyle['marginTop'] = -(theight/2) + 'px';
				this.imageStyle['backgroundImage'] = 'url('+ this.currentImage['im'] +')';
				// let im = new Image(),
				// 	_this = this;
				// im.onload = function() {
				// 	if (this.height/this.width > 1.25) {
				// 		let twidth = _this.$env.bw,
				// 			theight = twidth*this.height/this.width;
				// 		_this.imageStyle['width'] = twidth + 'px';
				// 		_this.imageStyle['height'] = theight + 'px';
				// 		_this.imageStyle['marginTop'] = -(theight/2) + 'px';
				// 	} else {
				// 		let theight = _this.$env.bw*1.25;
				// 		_this.imageStyle['width'] = theight*this.width/this.height + 'px';
				// 		_this.imageStyle['height'] = theight + 'px';
				// 		_this.imageStyle['marginTop'] = -(theight/2) + 'px';
				// 	}
				// 	_this.imageStyle['backgroundImage'] = 'url('+_this.currentImage['im']+')';
				// }
				// im.src = this.currentImage['im'];
			}
		}
	}
</script>

<style scoped lang="less">
	.page > * {
	    position: absolute;
	    overflow: hidden;
	}
	.page {
	    width: 100%;
	    height: 100%;
	    overflow: hidden;
	    position: absolute;
	}
	.scaleRound {
	    -webkit-animation: scaleRound 1.5s ease-in-out infinite alternate;
	}
	@keyframes scaleRound {
		0% {
		    transform: scale3d(1,1,1);
		}
		100% {
		    transform: scale3d(1.02,1.02,1.02);
		}
	}
	.dong4-im {
		animation: 1.2s linear 1.2s 1 normal both running div3_clip;
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;
	}
	@keyframes div3_clip {
		0% {
		    -webkit-clip-path: polygon( 0% 0%, 0% 0%, 100% 0%, 100% 0%);
		}
		100% {
		    -webkit-clip-path: polygon( 0% 0%, 0% 100%, 100% 100%, 100% 0%);
		}
	}
	.div41 {
		animation: 1s linear 1.2s 1 normal both running div41_clip;
	}
	.div42 {
		animation: 1s linear 1.2s 1 normal both running div42_clip;
	}
	.div43 {
		animation: 1s linear 1.2s 1 normal both running div43_clip;
	}
	.div44 {
		animation: 1s linear 1.2s 1 normal both running div44_clip;
	}
	.div45 {
		animation: 1s linear 1.2s 1 normal both running div45_clip;
	}
	@keyframes div41_clip {
		0% {
		    -webkit-clip-path: polygon( 0% 0%, 0% 0%, 100% 0%, 100% 0%);
		}
		100% {
		    -webkit-clip-path: polygon( 0% 0%, 0% 20%, 100% 20%, 100% 0%);
		}
	}
	@keyframes div42_clip {
		0% {
		    -webkit-clip-path: polygon( 0% 19%, 0% 19%, 100% 19%, 100% 19%);
		}
		100% {
		    -webkit-clip-path: polygon( 0% 19%, 0% 40%, 100% 40%, 100% 19%);
		}
	}
	@keyframes div43_clip {
		0% {
		    -webkit-clip-path: polygon( 0% 39%, 0% 39%, 100% 39%, 100% 39%);
		}
		100% {
		    -webkit-clip-path: polygon( 0% 39%, 0% 60%, 100% 60%, 100% 39%);
		}
	}
	@keyframes div44_clip {
		0% {
		    -webkit-clip-path: polygon( 0% 59%, 0% 59%, 100% 59%, 100% 59%);
		}
		100% {
		    -webkit-clip-path: polygon( 0% 59%, 0% 80%, 100% 80%, 100% 59%);
		}
	}
	@keyframes div45_clip {
		0% {
		    -webkit-clip-path: polygon( 0% 79%, 0% 79%, 100% 79%, 100% 79%);
		}
		100% {
		    -webkit-clip-path: polygon( 0% 79%, 0% 100%, 100% 100%, 100% 79%);
		}	
	}
</style>